import apiClient from "./axios";

/**
 * ULD库存预警 API
 */
export const uldStockAlertApi = {
    // 获取监控列表
    getMonitorList: () => apiClient.get("/v1/uld-stock-alerts/monitor"),

    // 添加监控站点
    addMonitor: (data) => apiClient.post("/v1/uld-stock-alerts", data),

    // 移除已有配置的监控站点
    removeMonitor: (configId) => apiClient.delete(`/v1/uld-stock-alerts/${configId}`),

    // 移除还没有配置记录、只是因为有库存才出现的机场
    hideAirport: (data) => apiClient.post("/v1/uld-stock-alerts/hide", data),

    // 更新预警配置
    updateConfig: ({ id, data }) => apiClient.put(`/v1/uld-stock-alerts/${id}`, data),

    // 批量更新配置
    // Backend expects List[int] for config_ids in the body, alongside data fields. 
    // But wait, FastAPI default body is Pydantic model. 
    // Let's adjust frontend to send both in a single JSON body or adjust backend to accept Body() for both.
    // Currently backend defines: `config_ids: List[int], data: UldStockAlertConfigUpdate`. 
    // FastAPI will expect body like: { "config_ids": [...], "data": { ... } } if not careful with Body embed.
    // Let's check backend signature again.
    batchUpdateConfigs: (configIds, data) => apiClient.post("/v1/uld-stock-alerts/batch-update", { config_ids: configIds, data }),

    // 手动触发预警检查
    // forceSend: true 表示强制发送，忽略7小时冷却期
    triggerAlertCheck: (forceSend = true) => apiClient.post("/v1/uld-stock-alerts/test/trigger-check", null, {
        params: { force_send: forceSend },
        timeout: 180000,
        _silentError: true,
    }),
};

